import React, { useRef, useEffect } from 'react';

export default function Contact() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.opacity = '0';
    ref.current.style.transform = 'translateY(24px)';
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        e.target.style.transition = 'opacity .9s ease, transform .9s ease';
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
      }
    }, { threshold: 0.1 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{`
        .contact-phone-link { color: #C9A84C; text-decoration: none; transition: opacity .3s; }
        .contact-phone-link:hover { opacity: 0.75; }
        .contact-cta-btn {
          background: #C9A84C; color: #0F1D48;
          font-family: 'Jost', sans-serif; font-size: .62rem;
          letter-spacing: 4px; text-transform: uppercase;
          padding: 1rem 2.8rem; border: none; cursor: pointer;
          font-weight: 500; transition: all .35s; display: inline-block;
        }
        .contact-cta-btn:hover { background: #E8C97A; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(201,168,76,.3); }
        .contact-ghost-btn {
          background: transparent; color: #F2E8D9;
          font-family: 'Jost', sans-serif; font-size: .62rem;
          letter-spacing: 4px; text-transform: uppercase;
          padding: 1rem 2.4rem; border: 1px solid rgba(242,232,217,.3);
          cursor: pointer; font-weight: 300; transition: all .35s;
        }
        .contact-ghost-btn:hover { border-color: #C9A84C; color: #C9A84C; }
      `}</style>

      <section id="contact" style={{ padding: '7rem 3rem', background: '#0F1D48' }}>
        <div ref={ref} style={{ maxWidth: '680px', margin: '0 auto', textAlign: 'center' }}>
          {/* Rule */}
          <div style={{ display:'flex', alignItems:'center', gap:'.8rem', justifyContent:'center', marginBottom:'1.5rem' }}>
            <div style={{ width:'40px', height:'1px', background:'#C9A84C' }}/>
            <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
            <div style={{ width:'40px', height:'1px', background:'#C9A84C' }}/>
          </div>

          <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.58rem', letterSpacing:'5px',
            textTransform:'uppercase', color:'#C9A84C', marginBottom:'.8rem', fontWeight:300 }}>
            Reservations &amp; Enquiries
          </p>

          <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,4vw,2.9rem)',
            fontWeight:500, color:'#F2E8D9', marginBottom:'.3rem' }}>
            Book Your Stay
          </h2>
          <h3 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(1.2rem,2.5vw,1.8rem)',
            fontStyle:'italic', fontWeight:400, color:'#C9A84C', marginBottom:'1.5rem' }}>
            with Shree Maya Comfort Inn
          </h3>

          <p style={{ fontFamily:"'EB Garamond',serif", fontSize:'1.05rem', lineHeight:1.9,
            color:'rgba(242,232,217,0.58)', marginBottom:'0.5rem' }}>
            Ready to experience true comfort? Our team is available around the clock
            to assist with your reservation or any enquiry.
          </p>

          {/* Phone */}
          <div style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.7rem,5vw,2.8rem)',
            letterSpacing:'3px', margin:'2rem 0' }}>
            <a href="tel:+919179954390" className="contact-phone-link">
              +91 91799 54390
            </a>
          </div>

          {/* Buttons */}
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
            <a href="tel:+919179954390">
              <button className="contact-cta-btn">Call Now to Reserve</button>
            </a>
            <a href="https://wa.me/919179954390" target="_blank" rel="noreferrer">
              <button className="contact-ghost-btn">WhatsApp Us</button>
            </a>
          </div>

          <p style={{ fontFamily:"'EB Garamond',serif", fontStyle:'italic',
            fontSize:'.92rem', color:'rgba(242,232,217,0.3)', marginTop:'2rem' }}>
            Walk-ins welcome · 24-hour front desk · Ujjain, Madhya Pradesh
          </p>
        </div>
      </section>
    </>
  );
}
